const PENDING_SUBMISSION_KEY = 'cpe-pending-submission-jid'

const setJid = jid => {
  try {
    window.sessionStorage.setItem(PENDING_SUBMISSION_KEY, jid)
  } catch {}
}

const getJid = () => {
  try {
    return window.sessionStorage.getItem(PENDING_SUBMISSION_KEY) || ''
  } catch {
    return ''
  }
}

const clearJid = () => {
  try {
    window.sessionStorage.removeItem(PENDING_SUBMISSION_KEY)
  } catch {}
}

const pendingSubmissionStorage = { setJid, getJid, clearJid }
export default pendingSubmissionStorage
